<template>
  <div>
    <div class="pt-0h mx-0h">
      <h1 class="pb-0">{{ $t('auth.account.header') }}</h1>
    </div>

    <TextInput
      v-model="email"
      class="mb-1"
      :label="$t('common.email')"
      disabled
    >
      <template #append>
        <div style="margin-right: .3rem">
          <Btn
            danger
            outline
            button
            type="button"
            @click.prevent="handleLogout"
          >
            {{ $t('common.logout') }}
          </Btn>
        </div>
      </template>
    </TextInput>

    <Btn
      v-if="!isDemo && appLabelConfig.poolLiveFront.profile.showAccountSettings"
      block
      outline
      button
      large
      class="mb-1"
      type="button"
      @click.prevent="openUserProfile"
    >
      {{ $t('auth.account.settings') }}
      <template #append>
        <IconComponent
          icon="aip-chevron-right"
          size="1rem"
        />
      </template>
    </Btn>

    <Btn
      block
      outline
      button
      large
      class="mb-1"
      type="button"
      @click.prevent="openHelp"
    >
      {{ $t('auth.account.help') }}
      <template #append>
        <IconComponent
          icon="aip-chevron-right"
          size="1rem"
        />
      </template>
    </Btn>
    <Btn
      v-if="!isDemo && appLabelConfig.auth.showTermsOfService"
      block
      outline
      button
      large
      class="mb-1"
      type="button"
      @click.prevent="termsStore.open()"
    >
      {{ $t('auth.account.terms') }}
    </Btn>
    <Btn
      block
      outline
      button
      large
      class="mb-1"
      type="button"
      @click.prevent="emit('onDone')"
    >
      {{ $t('common.cancel') }}
    </Btn>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import TextInput from '@acs/components-library/src/components/common/Input.vue';
import Btn from '@acs/components-library/src/components/common/Btn.vue';
import IconComponent from '@acs/components-library/src/components/common/Icon.vue';
import { logout, getUser, createUserPortalUrl } from '@acs/components-library/src/auth.js';
import * as auth from '@acs/components-library/src/auth.js';
import { isDemo as isDemoFn } from '@acs/components-library/src/demo.js';
import { appLabelConfig } from '@acs/components-library/src/appLabel/appLabelConfig.js';
import { useTermsStore } from '@acs/components-library/src/stores/termsStore';

const { VITE_HELP_EMAIL } = import.meta.env;

const { t } = useI18n();
const emit = defineEmits(['onDone']);

const termsStore = useTermsStore();

const email = ref('');
const isDemo = isDemoFn();

onMounted(async () => {
  if (isDemo) {
    email.value = 'demo@demo.demo';
    return;
  }

  const { email: userEmail } = await getUser();
  email.value = userEmail;

  // Re-fetch user on every modal open but do not block the UI if already loaded
  auth.fetchUser().then((userData) => {
    if (userData?.email) email.value = userData.email;
  });
});

async function handleLogout() {
  if (window.confirm(t('auth.account.confirmLogout'))) {
    await logout();
    emit('onDone');
    window.location.href = '/login';
  }
}

async function openUserProfile() {
  const url = await createUserPortalUrl('/profile/settings', 'poolLiveFront');
  window.open(url, '_blank');
}

function openHelp() {
  window.open(`mailto:${VITE_HELP_EMAIL}`, '_blank');
}
</script>

<style scoped lang="scss">

</style>
